export default __webpack_public_path__ + "static/media/help-active.16b72f04.svg";